import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { authLoginUrl, authRegisterUrl } from "../../config/routePaths";
import { registerSignInPrompt } from "../../utils/signInPromptBus";

export default function SignInPrompt() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [redirect, setRedirect] = useState("");

  useEffect(() => {
    registerSignInPrompt(({ reason: nextReason, redirect: nextRedirect }) => {
      const here = `${location.pathname}${location.search}`;
      setReason(nextReason || "Sign in to continue.");
      setRedirect(nextRedirect || here);
      setOpen(true);
    });
    return () => registerSignInPrompt(null);
  }, [location.pathname, location.search]);

  const close = () => setOpen(false);
  const go = (url) => {
    setOpen(false);
    navigate(url);
  };

  return (
    <Modal show={open} onHide={close} centered contentClassName="sign-in-prompt">
      <Modal.Header closeButton>
        <Modal.Title as="h2" className="h5 mb-0">
          Sign in to continue
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">{reason}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="outline-dark" onClick={close}>
          Not now
        </Button>
        <Button variant="outline-dark" onClick={() => go(authRegisterUrl(redirect))}>
          Create account
        </Button>
        <Button variant="primary" onClick={() => go(authLoginUrl(redirect))}>
          Sign in
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
